
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomepageRoutingModule } from './homepage-routing.module';
import { HomepageComponent } from './homepage.component';
import { SharedModule } from 'src/app/shared/shared.module';

import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ImageComponent } from './image/image.component';
import { BannerComponent } from './banner/banner.component';
import { BannerAdvancedModule } from '../../cms/banner-advanced/banner-advanced.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TemplateComponent } from './template/template.component';
import { BannerLayoutComponent } from './banner-layout/banner-layout.component';
import { VideoComponent } from './video/video.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BarcodePutModule } from '../../pos/directive/barcode-put/barcode-put.module';
import { TextEditorModule } from 'src/app/shared/text-editor/text-editor.module';
import { CopyTemplateComponent } from './template/copy-template/copy-template.component';
import { PricingTable5Component } from './pricing-table5/pricing-table5.component';
import { PdfComponent } from './pdf/pdf.component';
import { CommonImagesModule } from '../../common-images/common-images.module';
import { EcommercetemplateComponent } from './template/ecommercetemplate/ecommercetemplate.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';

@NgModule({
  declarations: [HomepageComponent, ImageComponent, BannerComponent, TemplateComponent, BannerLayoutComponent, VideoComponent, CopyTemplateComponent, PricingTable5Component, PdfComponent, EcommercetemplateComponent],
  imports: [
    CommonModule,
    HomepageRoutingModule,
    SharedModule,
    NgxMatSelectSearchModule,
    MatAutocompleteModule,
    BarcodePutModule,
    CommonFileUploadModule,
    BannerAdvancedModule,
    MatToolbarModule,
    TextEditorModule,
    CommonImagesModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatInputModule,
    MatButtonModule,
    CustomFlexLayoutModule
  ],
  exports: [TemplateComponent,BannerLayoutComponent,VideoComponent,PdfComponent]
})
export class HomepageModule { }
